import { z } from "zod";
/**
 * How a run is described.
 *
 * What is left after the browser workers went: which engines exist, how a run
 * ended, and the query shape a saved fan-out study is read in. The schemas that
 * described a worker's job, its result and its evidence are gone with the
 * workers; step 2's vendor adapter gets its own contract rather than inheriting
 * the browser's field by field.
 */
export const Engine = {
    chatgpt: "chatgpt",
    perplexity: "perplexity",
    google_ai_overview: "google_ai_overview",
    // Paid add-ons in the reference product, and the hardest to capture.
    // Deliberately last (build-plan.md P9).
    google_ai_mode: "google_ai_mode",
    gemini: "gemini",
    claude: "claude",
    // Microsoft Copilot, asked through Cloro (server/crates/api/src/capture/cloro).
    copilot: "copilot",
};
export const engineSchema = z.enum(Engine);
/**
 * How a capture ended. Every run gets exactly one.
 *
 * A failure is a recorded state, never a dropped job (AGENTS.md §1). Recording
 * `login_required` as "zero mentions" would silently corrupt every metric that
 * counts it.
 *
 * Every value stays, including the ones nothing writes any more: rows recorded
 * by the browser workers still carry them, and a screen has to be able to render
 * an old run as what it was rather than as an unknown state.
 */
export const TerminalState = {
    success: "success",
    login_required: "login_required",
    signup_required: "signup_required",
    challenge: "challenge",
    no_answer: "no_answer",
    site_error: "site_error",
    /**
     * Our selector no longer matched anything on a page that loaded fine.
     *
     * Deliberately NOT no_answer. The engine may well have answered; we could not
     * find the element to read. Filing that as "no answer" is a claim about the
     * engine based on a fault in our own adapter, and it is indistinguishable in
     * the data from a genuine empty result — so the metric silently drops while
     * looking healthy.
     */
    selector_drift: "selector_drift",
};
export const terminalStateSchema = z.enum(TerminalState);
//# sourceMappingURL=capture.js.map